<template>
  <div class="pdf" :style="{width: width + 'px', height: height + 'px'}">
    <iframe :src="perviewUrl" width="100%" height="100%" frameborder="0" scrolling="auto"/>
  </div>
</template>

<script>
  export default {
    name: 'Pdf',
    components: {

    },
    data() {
      return {
        perviewUrl: '',
        width: '',
        height: '',
      }
    },
    created() {
      const fileUrl = this.$route.query.url
      const fileName = this.$route.query.name
      let Base64 = require('js-base64').Base64
      var jointUrl = encodeURIComponent(Base64.encode(fileUrl))
      this.perviewUrl =  `https://mes.loncinindustries.com:10000/preview/onlinePreview?url=${jointUrl}`
      if (fileName) {
        document.title = fileName
      }
      this.width = 1200
      this.height = 2148
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .pdf {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pdf.vue